import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { getSessionId, getAttribution } from "../lib/attribution";

export default function PageTracker() {
  const loc = useLocation();
  useEffect(() => {
    if (loc.pathname.startsWith("/admin")) return;
    const attr = getAttribution();
    api.post("/track", {
      path: loc.pathname,
      session_id: getSessionId(),
      ...attr,
    }).catch(() => {});
  }, [loc.pathname]);
  return null;
}
